(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react-dom"), require("zebDshAuthentication"), require("react"), require("@emotion/react"));
	else if(typeof define === 'function' && define.amd)
		define("zebDshAppFrame", ["react-dom", "zebDshAuthentication", "react", "@emotion/react"], factory);
	else if(typeof exports === 'object')
		exports["zebDshAppFrame"] = factory(require("react-dom"), require("zebDshAuthentication"), require("react"), require("@emotion/react"));
	else
		root["zebDshAppFrame"] = factory(root["zebDshVendor"]["reactDOM"], root["zebDshAuthentication"], root["zebDshVendor"]["react"], root["zebDshVendor"]["emotionReact"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__5366__, __WEBPACK_EXTERNAL_MODULE__5218__, __WEBPACK_EXTERNAL_MODULE__3439__, __WEBPACK_EXTERNAL_MODULE__5692__) => {
return 